$(document).ready(function(){

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').removeClass('quicklinksMenuFixed--open').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- footer quicklinks sticky --
	$('.btn__quicklinksMenuFixed').on('click', function(){
		$('body').removeClass('mainMenu--open').toggleClass('quicklinksMenuFixed--open');
		$('.hamburger').removeClass('is-active');
	});

	// -- resize --
	$(window).on('resize orientationchange', function(){
		if ($(window).width() >= 1024) {
			$('body').removeClass('quicklinksMenuFixed--open mainMenu--open');
			$('.hamburger').removeClass('is-active');
		}
	});

	// -- scroll --
	$(window).on('scroll resize orientationchange', function(){
		var scrollTop = $(window).scrollTop();
		var headerH = $('.header').outerHeight();
		if (scrollTop > headerH) {
			$('.header').removeClass('absolute').addClass('fixed');
		} else {
			$('.header').removeClass('fixed').addClass('absolute');
			$('.header .dropdown__list').removeClass('open');
		}
	});

	// -- click on header absolute --
	$(document).on('click', '.header.absolute .level--1.dropdown .menu-item', function(e){
		if ($(window).width() >= 1024) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: $('#main').offset().top + 1
			}, 'fast');
			setTimeout(function(){
				$(e.currentTarget).next('.dropdown__list').addClass('open');
			},400);
		}
	});

});